module.exports = __webpack_public_path__ + "static/media/venic-vs-code3.24276304.png";